module.exports = __webpack_public_path__ + "img/5800320ae96e48890de5c82ff12d580d.png";